"use client"

import { CheckCircle, Globe, Clock, FileCheck, Users } from "lucide-react"
import { Helmet } from 'react-helmet-async';
import logo from '../../asset/logo.jpg'
import { motion } from 'framer-motion';
import { Link } from "react-router-dom";
import visaa from '../../asset/visa.jpg'
function VisaContent() {
  const visaTypes = [
    {
      icon: CheckCircle,
      name: "Tourist Visas",
      description:
        "Perfect for leisure travelers exploring new destinations. Typically valid for 30 days to 6 months depending on the country.",
    },
    {
      icon: Users,
      name: "Business Visas",
      description:
        "Designed for professionals attending meetings, conferences, or business negotiations abroad. Usually valid for 1-2 years.",
    },
    {
      icon: CheckCircle,
      name: "Student Visas",
      description:
        "For academic pursuits abroad. Requires admission from an educational institution and proof of financial support.",
    },
    {
      icon: Clock,
      name: "Work Visas",
      description:
        "Employment visas for long-term work opportunities. Requirements vary by country and employer sponsorship.",
    },
  ]

 

 

  return (
    <div className="min-h-screen bg-background">
     <Helmet>
  <title>Visa Services — YS Sky Travel and Tour Agency P.L.C</title>
  <meta name="description" content="Fast and reliable visa application assistance for all destinations." />
</Helmet>


     
   <section className="relative h-72 bg-gradient-to-r from-primary-900 via-medical-600 to-blue-600 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src={logo}
            alt="Contact us"
            className="w-full h-full object-cover opacity-20"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/80 to-medical-600/60"></div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-center w-full animate-fade-in">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
           Visa Processing
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto leading-relaxed">
           Seamless visa solutions for hassle-free international travel
            </p>
          </div>
        </div>

        {/* Animated Elements */}
        <div className="absolute top-20 right-20 w-32 h-32 bg-white/10 rounded-full animate-float"></div>
        <div className="absolute bottom-20 left-20 w-24 h-24 bg-white/10 rounded-full animate-float" style={{ animationDelay: '2s' }}></div>
      </section>
      {/* Service Overview */}
      <section className="py-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="bg-card border border-border rounded-2xl p-8 mb-16">
            <h2 className="text-3xl font-bold mb-6 text-primary">About Our Visa Processing Service</h2>
            <div className="space-y-4 text-muted-foreground leading-relaxed">
              <p>
               At YS Sky Travel and Tour Agency PLC, we make visa processing simple and stress-free. We assist with visas for over 150 destinations, handling everything from document preparation to embassy submission.
              </p>
              <p>
               With expert support, fast processing, and clear fees, we help you get your visa smoothly so you can focus on your travel plans.
              </p>
            
            </div>
          </div>

          {/* Visa Types */}
          <div className="mb-16">
            <h2 className="text-3xl font-bold mb-10 text-primary">Visa Types We Process</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              {visaTypes.map((visa, idx) => {
                const Icon = visa.icon
                return (
                  <div
                    key={idx}
                    className="bg-card border border-border rounded-xl p-6 hover:border-accent transition-colors"
                  >
                    <Icon className="w-10 h-10 text-accent mb-4" />
                    <h3 className="font-bold text-lg mb-2">{visa.name}</h3>
                    <p className="text-muted-foreground text-sm leading-relaxed">{visa.description}</p>
                  </div>
                )
              })}
            </div>
          </div>

       

          {/* Our Process */}
          <div className="bg-gradient-to-br from-green-500/10 to-emerald-500/10 rounded-2xl p-8 border border-green-200/50 dark:border-green-800/50 mb-16">
            <h2 className="text-2xl font-bold mb-8 text-primary">Visa Processing Steps</h2>
            <div className="grid md:grid-cols-4 gap-6">
              {[
                {
                  step: 1,
                  title: "Consultation",
                  description: "Free assessment to determine visa type and requirements",
                },
                {
                  step: 2,
                  title: "Documentation",
                  description: "Guided collection and preparation of all required documents",
                },
                {
                  step: 3,
                  title: "Application",
                  description: "Professional submission and tracking of your visa application",
                },
                {
                  step: 4,
                  title: "Delivery",
                  description: "Secure delivery of your approved visa to your desired location",
                },
              ].map((item) => (
                <div key={item.step} className="relative">
                  <div className="bg-card border border-border rounded-lg p-6 text-center">
                    <div className="w-12 h-12 rounded-full bg-accent text-accent-foreground flex items-center justify-center text-xl font-bold mx-auto mb-3">
                      {item.step}
                    </div>
                    <h3 className="font-bold mb-2">{item.title}</h3>
                    <p className="text-muted-foreground text-sm">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Coverage */}
     <div className="grid md:grid-cols-2 gap-8 mb-4">
      <div className="bg-gradient-to-br from-primary/5 to-primary-dark/5 border border-border rounded-2xl flex flex-col ">
  <motion.div 
              className="relative"
              initial={{ opacity: 0, y: 40, scale: 0.95 }}
              whileInView={{ opacity: 1, y: 0, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <img
                src={visaa}
                alt="Our clinic"
                className="w-full h-96 object-cover rounded-2xl shadow-2xl"
              />
             
            </motion.div>
            </div>
  {/* LEFT CARD */}
  <div className="bg-gradient-to-br from-green-500/10 to-emerald-500/10 rounded-2xl p-8 border border-border">
    <h3 className="text-2xl font-bold mb-6 text-primary">Why Choose Our Visa Service</h3>
    <ul className="space-y-3">
      {[
        "Expert knowledge of visa requirements for 150+ countries",
        "Proven track record of successful visa approvals",
        "Fast processing with optional expedited services",
        "24/7 customer support",
        "Secure document handling and privacy protection",
      ].map((item, idx) => (
        <li key={idx} className="flex gap-3 items-start">
          <FileCheck className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" />
          <span className="text-foreground text-sm">{item}</span>
        </li>
      ))}
    </ul>
  </div>

  {/* RIGHT CARD WITH BEAUTIFUL BUTTON */}


</div>

  <div className="bg-gradient-to-br from-primary/5 to-primary-dark/5 border border-border rounded-2xl p-8 flex flex-col items-center justify-center text-center">
    <h3 className="text-2xl font-bold mb-4 text-primary">Need Visa Assistance?</h3>
    <p className="text-sm text-muted-foreground mb-8 max-w-md">

      Contact us for fast, reliable, and professional support.
    </p>

    <motion.div
      whileHover={{ y: -3 }}
      whileTap={{ scale: 0.97 }}
    >
      <Link
        to="/contact"
        className="px-8 py-3 rounded-full 
                   bg-gradient-to-r from-primary to-primary-dark
                   text-white font-semibold tracking-wide
                   shadow-[0_4px_20px_rgba(0,0,0,0.12)]
                   hover:shadow-[0_6px_28px_rgba(0,0,0,0.18)]
                   transition-all duration-300 backdrop-blur-md"
      >
        Contact Us
      </Link>
    </motion.div>
  </div>
          
        </div>
      </section>

     
    </div>
  )
}

export default function Visa() {
  return (

      <VisaContent />
  
  )
}
